import { fetchFromApi } from "./fetchFromApi";

import {selectPreviousLeagueSeason} from "./previousLeagueSeasonSelection";
export {selectPreviousLeagueSeason} from "./previousLeagueSeasonSelection";

export async function loadPreviousLeagueSeason(seasonId) {
  const currentResponse = await (await fetchFromApi(`fetch-data-v3/seasons/${seasonId}?include=league`)).json();
  const currentSeason = currentResponse?.data;
  if (!currentSeason?.league_id || !currentSeason?.starting_at) return { currentSeason: currentSeason || null, previousSeason: null };
  const seasons = [];
  let page = 1;
  while (true) {
    const response = await (await fetchFromApi(`fetch-data-v3/seasons?include=league&per_page=50&page=${page}`)).json();
    if (Array.isArray(response?.data)) seasons.push(...response.data);
    if (!response?.pagination?.has_more) break;
    page += 1;
    if (page > 100) throw new Error("Pagination limit exceeded while loading seasons.");
  }
  return { currentSeason, previousSeason: selectPreviousLeagueSeason(currentSeason, seasons) };
}
